// extracted by mini-css-extract-plugin
export default {"toolbar":"lsf-toolbar","toolbar__group":"lsf-toolbar__group","toolbar_expanded":"lsf-toolbar_expanded","waiting":"lsf-waiting"};